import getPermissions from 'config/getPermissions';



export const types = {
	SET_AUTH: 'AUTH/SET_AUTH',
};

export const initialState = {
	token: null,
	sid: null,
	pending: false,
	resumePending: false,
	authenticated: false,
	permissions: getPermissions([]),
};


export default (state = initialState, action) => {
	switch (action.type) {
		case types.SET_AUTH:
			return { ...state, ...action.data };

		default:
			return state
	}
}

export const actions = {
	setAuth: (data) => ({ type: types.SET_AUTH, data }),
};